import type { Appearance } from "generator/components/button-appearance";
import * as React from "react";
import type { OnClickHandler } from "hooks/use-on-click-from-action";
import { ButtonBarViewStyle } from "./button-bar-view-style";
import Button from "../../smart/button/button";
import type { Mood } from "generator/components/mood";
import type { AppKind } from "common/components/app-kind";

export interface ButtonBarViewProps {
    readonly titleLeft?: string;
    readonly appearanceLeft: Appearance;
    readonly moodLeft: Mood;

    readonly onClickLeft: OnClickHandler | undefined;
    readonly urlLeft: string | undefined;
    readonly iconLeft?: string;

    readonly titleRight?: string;
    readonly appearanceRight: Appearance;
    readonly moodRight: Mood;
    readonly onClickRight: OnClickHandler | undefined;
    readonly urlRight: string | undefined;
    readonly iconRight?: string;

    readonly appKind: AppKind;
}

interface Props extends ButtonBarViewProps {}

class ButtonBarInner extends React.Component<Props> {
    public render(): React.ReactNode {
        const {
            titleLeft,
            appearanceLeft,
            onClickLeft,
            urlLeft,
            iconLeft,
            titleRight,
            appearanceRight,
            onClickRight,
            urlRight,
            iconRight,
            moodRight,
            moodLeft,
            appKind,
        } = this.props;

        return (
            <ButtonBarViewStyle>
                <Button
                    includeMargin={false}
                    title={titleLeft}
                    url={urlLeft}
                    floatingIcon={iconLeft}
                    appearance={appearanceLeft}
                    mood={moodLeft}
                    onClick={onClickLeft ?? (async () => undefined)}
                    disabled={onClickLeft === undefined}
                    appKind={appKind}
                />
                <Button
                    includeMargin={false}
                    title={titleRight}
                    url={urlRight}
                    floatingIcon={iconRight}
                    appearance={appearanceRight}
                    mood={moodRight}
                    onClick={onClickRight ?? (async () => undefined)}
                    disabled={onClickRight === undefined}
                    appKind={appKind}
                />
            </ButtonBarViewStyle>
        );
    }
}

export const ButtonBarView = ButtonBarInner;
